import {
  queryDataDictionaryListLang,
  searchStoreList,
  resourceListByRole,
  appInit,
  getAuthCode,
  searchOrganizationList,
  loginByAuthCode,
  queryOrganizationTree,
  getLanguages,
  queryDistrict,
  getOrganization,
  getSystemValue,
  queryMenuListByRole,
  exportProductExcel,
  exportProductExcelKone,
  queryExportFile,
  queryExcelExportFile,
  downLoadExcelFile,
  grantExportFileAccessUrl,
  getCartCount,
  queryMemberMessageList,
  saveMessageLog,
  getMemberMessageCount,
  subtractMemberMessageCount,
  refreshMemberMessageCount,
  getMemberStatus
} from "@root/graphql/Root.gql";

// sub modules
import productPicker from "./children/ProductPicker.ts";
import layout from "./children/Layout.ts";
import memberPicker from "./children/memberPicker.ts";
import ImportExport from "./children/ImportExport.ts";

// methods
import { easyMutate, resRest } from "@root/lib/utils";
import Vue from "vue";
import permissionList from "@root/permissions";
import {
  K1_PCR_apolloClient,
  K1_TBR_apolloClient,
  K1_YGJ_apolloClient
} from "@root/lib/allApolloClient";
import { httpServer as pcrHttp } from "@root/lib/axios/pcrAxios";
import { httpServer as ygjHttp } from "@root/lib/axios/ygjAxios";

import { setGlobalState } from "@root/lib/qiankun/actions.ts";

// const lang = i18nInstance.locale;
const lang = "zh-CN";
const DDCODES_MAP_CACHE = {};

export default {
  namespaced: true,
  modules: {
    productPicker,
    layout,
    memberPicker,
    ImportExport
  },
  state: {
    isCollapse: false,
    menuList: [],
    permission: {},
    languageList: [],
    ddCodes: {},
    headerOrgName: "",
    headerCartNum: 0,
    memberMessageList: [],
    activeRoute: {},
    mainRouter: null,
    msgCount: 0
  },
  getters: {
    // ddCodeMap 不建议继续使用
    ddCodeMap({ ddCodes }) {
      for (let key in ddCodes) {
        if (
          !DDCODES_MAP_CACHE.hasOwnProperty(key) &&
          ddCodes[key] instanceof Array &&
          ddCodes[key].length
        ) {
          DDCODES_MAP_CACHE[key] = toMapByValue(ddCodes[key]);
        }
      }

      return DDCODES_MAP_CACHE;
    },
    menuList(state, getters) {
      // const isDevelopmentMode = process.env.NODE_ENV === "development";
      const menu = [];

      state.menuList.forEach(v => {
        let { children = [] } = v;

        if (children && children.length != 0) {
          let { menuName: name, menuIcon: icon, menuCode: code } = v;

          let newChildren =
            children &&
            children.map(ele => {
              let {
                menuName: name,
                menuIcon: icon,
                pageUrl: path,
                menuCode: code
              } = ele;
              return { name, icon, path, code };
            });

          menu.push({
            name,
            icon,
            code,
            children: newChildren
          });
        } else {
          let {
            menuName: name,
            menuIcon: icon,
            pageUrl: path,
            menuCode: code
          } = v;
          menu.push({
            name,
            icon,
            path,
            code
          });
        }
      });
      // if (isDevelopmentMode) {
      //   menu.push(...getters.developmentMenu);
      // }
      return menu;
    }
  },
  actions: {
    // app 初始化数据
    async appInit({ rootState, commit, state }, variables) {
      const permission = {};
      let { data } = await rootState.gql.query({
        query: appInit,
        variables: variables
      });
      // 写死的权限配置，permission setting config
      // data.permission.map(
      permissionList.forEach(
        ({ positionCode: key = null }) => key && (permission[key] = true)
      );
      commit("easyMutate", { path: "permission", data: permission });

      // portal infomation | 关于portal的信息
      localStorage.setItem("SYSTEM_DATA", data.portal.valueValue);

      // default currency | 默认币种
      localStorage.setItem("SYSTEM_DEFAULT_CURRENCY", data.currency.valueValue);
    },
    // 获取token
    async getAuthCode({ rootState, commit }, data) {
      let res = await rootState.gql.query({
        query: getAuthCode,
        variables: data
      });
      return res.data;
    },

    // 获取字典
    async queryDD({ commit, rootState }, { statePath: path, ddCode }) {
      const res = await rootState.gql.query({
        query: queryDataDictionaryListLang,
        variables: {
          input: {
            lang,
            ddCode
          }
        }
      });

      commit("easyMutate", {
        path,
        data: res.data.api || []
      });
    },

    // 模糊查新门店列表
    async searchStoreList(
      { commit, rootState },
      {
        pageInput = { pageSize: 1000, pageNum: 1 },
        searchKey = "",
        cb = list =>
          list.filter(item => item.status === 1 && item.openStatus === 1)
      }
    ) {
      const res = await rootState.gql.query({
        query: searchStoreList,
        variables: {
          pageInput,
          searchKey
        }
      });

      const list = resRest(res.data);

      commit("easyMutate", {
        path: "storeList",
        data: cb ? cb(list) : list
      });
    },

    // 权限
    async queryResourceListByRole({ commit, rootState }, resourceParent) {
      const {
        data: { api: list }
      } = await rootState.gql.query({
        query: resourceListByRole,
        variables: {
          resourceParent
        }
      });

      const permission = {};

      list.map(
        ({ positionCode: key = null }) => key && (permission[key] = true)
      );

      // commit("easyMutate", { path: "permission", data: permission });
    },

    // 菜单
    async menuListByRole({ commit, rootState }, data) {
      // const {
      //   data: { res }
      // } = await rootState.gql.query({
      //   query: queryMenuListByRole,
      //   variables: {
      //     menuType: "2",
      //     ...datap
      //   }
      // });
      const res = await ygjHttp({
        url: "/menu/menuListByRole?menuType=2&roleCode=" + data.roleCode
      });
      // const res: any = await pcrHttp(
      //   "/menu/menuListByRole?menuType=2&roleCode=" + data.roleCode,
      //   {}
      // );
      console.log(res, "---菜单");
      // return data ? data.data : false;
      let list: any = res.data || [];
      list = list.filter(_ => _.resourceCode !== "K1_App");
      localStorage.setItem("menuList", JSON.stringify(list));
      commit("easyMutate", { path: "menuList", data: list });
      return res;
    },
    async menuListByRole2({ commit, rootState }, data) {
      const res = await ygjHttp({
        url: "/menu/menuListByRole?menuType=2&roleCode=" + data.roleCode
      });
      console.log(res, "---菜单");
      let list: any = res.data || [];
      list = list.filter(_ => _.resourceCode !== "K1_App");
      return list;
    },
    // 轮询账号是否需要被踢出（修改角色权限之后）
    async refreshAccount({ commit, rootState }, data) {
      const res = await ygjHttp({
        url: "/account/refresh"
      });
    },

    // permission
    permissionIt({ state }, key) {
      return state.permission.hasOwnProperty(key);
    },

    // 线下的组织
    async getOrganizationList({ rootState }, { origin, ...variables }) {
      const {
        data: {
          api: { datalist = [] }
        }
      } = await rootState.gql.query({
        query: searchOrganizationList,
        variables
      });

      return datalist && datalist.length
        ? datalist.map(({ data: { orgName: label, orgCode: value } }) => ({
            label,
            value
          }))
        : [];
    },

    // login
    async loginByAuthCode({ rootState, commit }, authCode) {
      const res = await rootState.gql.query({
        query: loginByAuthCode,
        variables: {
          authCode
        }
      });

      return res.data.loginByAuthCode;
    },

    async exportProductExcel({ commit, state, rootState }: any, data?: any) {
      let res = await rootState.gql.mutate({
        mutation: exportProductExcel,
        variables: { condition: { ...data } }
      });
      return res.data.exportProductExcel;
    },
    async exportProductExcelKone(
      { commit, state, rootState }: any,
      data?: any
    ) {
      const res = await rootState.gql.query({
        query: exportProductExcelKone,
        variables: data
      });
      return res;
    },

    async queryExportFile({ commit, state, rootState }: any, data: any) {
      let {
        data: resData,
        data: {
          api: {
            pageInfo: { totalCount = 0 }
          }
        }
      } = await rootState.gql.query({
        query: queryExportFile,
        variables: data
      });
      const list = resData ? resRest(resData) : [];

      return {
        total: totalCount,
        list
      };
    },

    async grantExportFileAccessUrl(
      { commit, state, rootState }: any,
      data: any
    ) {
      let {
        data: {
          grantExportFileAccessUrl: { accessUrl }
        }
      } = await rootState.gql.query({
        query: grantExportFileAccessUrl,
        variables: data
      });

      return accessUrl;
    },

    async queryOrganizationTree({ commit, state, rootState }: any, data) {
      let res = await rootState.gql.query({
        query: queryOrganizationTree,
        variables: data
      });
      return res.data.queryOrganizationTree;
    },

    // 获取当前租
    async getLanguages({ commit, rootState }, ddCode = "LANGUAGE_CODE") {
      const {
        data: resData,
        data: {
          tenantLanguages: { languages }
        }
      } = await rootState.gql.query({
        query: getLanguages,
        variables: {
          input: {
            ddCode
          }
        }
      });

      const allList = resRest(resData);
      const resultList = (languages.split(";") || []).map(val => {
        const { value, label } = allList.find(item => item.value === val);
        return { value, label };
      });

      commit("easyMutate", {
        data: resultList,
        path: "languageList"
      });
    },

    // 获取省市区
    async queryDistrict({ rootState, commit, state }, data = {}) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: queryDistrict,
        variables: {
          pageInput: {
            pageSize: 10000,
            pageNum: 1
          },
          input: {
            districtPcode: data,
            tenantCode: localStorage.getItem("tenantCode") || ""
          }
        }
      });

      return api.dataList.map(v => v.node);
    },
    async getOrganization({ commit, state, rootState }: any, data) {
      let res = await rootState.gql.query({
        query: getOrganization,
        variables: data
      });
      return res.data.getOrganization;
    },
    async getSystemValue({ rootState }, data) {
      let res = await rootState.gql.query({
        query: getSystemValue,
        variables: {
          input: data
        }
      });
      return res.data.data;
    },
    async queryChannelList({ commit, rootState }, data) {
      const res = await rootState.gql.query({
        query: queryDataDictionaryListLang,
        variables: { ...data }
      });

      return res.data.api;
    },

    // 获取导出导出文件历史
    async queryExcelExportFile({ rootState }, params = {}) {
      const {
        data,
        data: {
          api: {
            pageInfo: { total }
          }
        }
      } = await rootState.gql.query({
        query: queryExcelExportFile,
        variables: params
      });
      return {
        list: resRest(data),
        total
      };
    },

    async downLoadExcelFile({ commit, state, rootState }: any, data: any) {
      const res = await rootState.gql.query({
        query: downLoadExcelFile,
        variables: data
      });
      return res && res.data && res.data.downLoadExcelFile;
    },
    // 获取字典
    async queryDataDictionaryListLang({ commit, rootState }, param) {
      const { data = {} } = await rootState.gql.query({
        query: queryDataDictionaryListLang,
        variables: param
      });
      return data.api || [];
    },

    // 获取购物车数量
    async getCartCount({ commit, rootState }, param) {
      const { data = {} } = await K1_YGJ_apolloClient.query({
        query: getCartCount,
        variables: param
      });
      commit("SET_HEADER_CART_NUM", data.api ? data.api.code : 0);
      // return data.api ? data.api.code : 0;
    },

    async queryMemberMessageList({ commit, rootState }, params) {
      const { data } = await K1_YGJ_apolloClient.query({
        query: queryMemberMessageList,
        variables: params
      });
      console.log(data, "88");
      let result = {
        list: resRest(data) || [],
        total: data.api.pageInfo.totalCount
      };

      commit("SET_MEMBER_MESSAGE_LIST", result.list);
      return result;
      // return data ? data.api : [];
    },
    async saveMessageLog({ commit, state, rootState }: any, data?: any) {
      let res = await K1_YGJ_apolloClient.mutate({
        mutation: saveMessageLog,
        variables: data
      });
      return res.data.saveMessageLog;
    },

    async getMemberMessageCount(
      { commit, state, rootState }: any,
      params: any
    ) {
      let { data } = await K1_YGJ_apolloClient.query({
        query: getMemberMessageCount,
        variables: params
      });
      let res: any = data ? data.api : {};
      let result: any = res.code ? Number(res.code) : 0;
      commit("SET_MESSAGE_COUNT", result);
      return data ? data.api : {};
    },
    async subtractMemberMessageCount(
      { commit, state, rootState }: any,
      data?: any
    ) {
      let res = await K1_YGJ_apolloClient.mutate({
        mutation: subtractMemberMessageCount,
        variables: data
      });
      return res.data.api;
    },
    async refreshMemberMessageCount(
      { commit, state, rootState }: any,
      data?: any
    ) {
      let res = await K1_YGJ_apolloClient.mutate({
        mutation: refreshMemberMessageCount,
        variables: data
      });
      return res.data.api;
    },

    async getMemberStatus({ commit, state, rootState }: any, params: any) {
      let { data } = await K1_YGJ_apolloClient.query({
        query: getMemberStatus,
        variables: params
      });
      return data ? data.api : {};
    }
  },
  mutations: {
    easyMutate,

    UPDATE_DDCODE(state, { name, value }) {
      Vue.set(state.ddCodes, name, value);
    },

    CLEAR_DDCOED(state) {
      Object.keys(state.ddCodes).forEach(key => {
        Vue.set(state.ddCodes, key, /_MAP$/.test(key) ? {} : []);
      });
    },

    SET_HEADER_ORG_NAME(state, name) {
      state.headerOrgName = name;
    },
    SET_HEADER_CART_NUM(state, data) {
      state.headerCartNum = data;
      if (window.__POWERED_BY_QIANKUN__) {
        console.log(data, 888);
        setGlobalState({
          headerCartNum: data
        });
      }
    },
    SET_MEMBER_MESSAGE_LIST(state, data) {
      state.memberMessageList = data.filter(item => Number(item.isRead) === 0);
    },
    // 给qiankun项目传值使用，其他时候不要用
    UPDATE_GLOBAL_STATES(state, { key, value }) {
      Vue.set(state, key, value);
    },
    SET_MAIN_ROUTER(state, data) {
      state.mainRouter = data;
    },
    SET_MESSAGE_COUNT(state, data) {
      state.msgCount = data;
      if (window.__POWERED_BY_QIANKUN__) {
        setGlobalState({
          msgCount: data
        });
      }
    }
  }
};

export function toMapByValue(list, labelKey = "label", valueKey = "value") {
  let map = {};

  list.forEach(item => {
    const value = item[valueKey];
    const label = item[labelKey];

    // 部分字典数据的value是由多个值以逗号连接的
    if (/,/.test(value)) {
      value.split(",").forEach(val => (map[val] = label));
    } else {
      map[value] = label;
    }
  });

  return map;
}
